module.exports = __webpack_public_path__ + "static/media/80.85e12340.png";